import React from "react";
import Top from '../Top'
import Footer from '../Footer'
import {
    Breadcrumb,
    Layout,
    Row,
    Col,
    Descriptions,
    Button,
    Spin,
    Tabs,
    Badge,
    Tag,
    Radio,
    message,
    Modal,
    Pagination,
    Select,
    Popover,
    Tooltip
} from "antd";
import { projectDetailInfo, projectWebDetailInfo, getRoomTypeByProject, myQueueList, getApplyingTransaction, applyQueue, getUserHouseListInProject, userReserve } from '../../../utils/api'
import { connect } from "react-redux";
import actionWays from '../../../redux/actions';
import { Navigation, Scrollbar, A11y, Autoplay } from 'swiper/swiper.esm.js'
import { Swiper, SwiperSlide } from "swiper/react/swiper-react"
import SurroundingFacility from '../SurroundingFacility'
import { EllipsisOutlined } from '@ant-design/icons'
import "swiper/swiper.scss"
import './belows.scss'
import { width } from "dom7";
const { TabPane } = Tabs;
const { Option } = Select;

class Belows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projectList: '',
            loading: false,
            projectName: '...',
            selectNum: 0,
            selectTabIndex: 0,
            selectTabArr: ['地铁站', '公交站'],
            point: null,
            mapListContainerLoading: true,
            defaultRoom: '',
            roomTypeMsg: {},
            baiduIndex: '地铁站',
            baiduLoading: false,
            isLineup: false,
            isSubscribe: false,
            houseList: [],
            transactionNo: '',
            batchId: '',
            houseTypeVisible: false,
            houseVisible: false,
            current: 1,
            isModalVisible: false,
            paiduiHouseType: '',
            houseTypeAIndex: 0,
            houseIndex: 0,
            applyType: '',
            isYuyue: false,
            idnoJiaoyan: null
        }
        this.map = null
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        if (!this.props.location.query || this.props.location.query == undefined) {
            this.props.history.push('/home')
            return
        }
        this.setState({
            projectName: this.props.location.query.projectName
        })
        // this.setState({
        //     projectName: this.props.location.query.projectName
        // }, () => { this.getHouseList('一户室') })
        this.getprojectDetailInfo(this.props.location.query.projectName, this.props.location.query.projectNo)
        if (this.props.userLoginInfo && this.props.userLoginInfo.id) this.getLineup()
        this.getidnoG(this.props.userLoginInfo?.idno)
    }
    // 分页
    changeCurrent = (page) => {
        this.setState({
            current: page,
        }, () => {
            this.getHouseList(this.state.applyHouseType)
        });
    }
    // 判断排队预约按钮
    getLineup = async () => {
        let opt = {}
        opt.userId = this.props.userLoginInfo ? this.props.userLoginInfo.id : ''
        // 获取排队状态
        let data = await myQueueList('')
        if (data.code == 0) {
            if (data.data.length === 0 || (data.data.length >= 1 && data.data[0].status === '已过号') || (data.data.length >= 1 && data.data[0].status === '失效') || (data.data.length >= 1 && data.data[0].status === '排队失效') || (data.data.length >= 1 && data.data[0].status === '排队结束')) {
                this.setState({
                    isLineup: true,
                    isSubscribe: false,
                })
            } else if (data.data[0].status === '排队成功') {
                this.setState({
                    isLineup: false,
                    isSubscribe: true,
                    batchId: data.data[0].batchId,
                    applyHouseType: data.data[0].houseType
                })
                // 判断是否排队中来获取房源列表
                let date = await getApplyingTransaction(opt)
                if (date.code == 0) {
                    if (date.data && date.data.progress == '成功') {
                        this.setState({
                            transactionNo: date.data.transactionNo,
                            transactionValidStart: date.data.transactionValidStart,
                            transactionValidEnd: date.data.transactionValidEnd,
                        }, () => {
                            this.getHouseList(this.state.applyHouseType)
                        })
                    }
                } else {
                    message.error('请先去申请准入资格证');
                }
            }
        }
    }
    // 获取房源列表
    getHouseList = async (roomTypeName) => {
        let num = { '1': '一', '2': '二', '3': '三', '4': '四', '5': '五', '6': '六', '7': '七', '8': '八', '九': '九', '10': '十' }
        let china = roomTypeName.slice(0, 1)
        let opt = {}
        opt.roomTypeName = num[china] + '居室'
        opt.projectName = this.state.projectName
        opt.pageIndex = this.state.current - 1
        opt.pageSize = 10
        opt.userId = this.props.userLoginInfo.idno
        let data = await getUserHouseListInProject(opt)
        if (data.code == 0) {
            if (data.data.pageContent && data.data.pageContent.length > 0) {
                data.data.pageContent.forEach(function (item) {
                    if (item.roomPicUrl) {
                        item.roomPicUrl = item.roomPicUrl.split(',')
                    }
                });
                console.log('房源列表', data.data.pageContent);
                this.setState({
                    houseList: data.data.pageContent,
                    totalHouseList: data.data.count
                })
            }
        }
    }
    // 点击排队
    onLineup = async () => {
        let opt = {}
        opt.userId = this.props.userLoginInfo.id
        let data = await getApplyingTransaction(opt)
        if (data.code == 0) {
            if (data.data) {
                if (data.data.progress == '成功') {
                    this.lineup(this.state.paiduiHouseType, data.data.transactionNo)
                } else {
                    message.error('准入资格证正在审核中，请等待');
                }
            } else {
                message.error('请先去申请准入资格证');
            }
        } else {
            message.error(data.message);
        }
    }

    // 发起排队
    lineup = async (houseType, transactionNo) => {
        let obj = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10 }
        let china = houseType.slice(0, 1)
        let opt = {}
        // opt.idno = this.props.userLoginInfo.idno
        opt.projectName = this.state.projectName
        // opt.projectNo = this.state.projectNo
        opt.houseType = obj[china]
        opt.transactionNo = transactionNo
        let data = await applyQueue(opt)
        if (data.code == 0) {
            message.success('正在排队中')
            this.getLineup()
        } else {
            message.error(data.message);
        }
    }
    // 预约
    showYuyue = (houseId, houseType, houseName) => {
        this.setState({
            houseId: houseId,
            houseType: houseType,
            houseName: houseName,
            isYuyue: true
        })
    }
    setUserReserve = async () => {
        const { batchId, transactionNo, projectName, transactionValidStart, transactionValidEnd, houseId, houseType, houseName } = this.state
        let opt = {}
        // opt.userId = this.props.userLoginInfo.id
        opt.batchId = batchId
        opt.transactionNo = transactionNo
        // opt.projectName = projectName
        // opt.houseName = houseName
        // opt.transactionValidStart = transactionValidStart
        // opt.transactionValidEnd = transactionValidEnd
        opt.houseId = houseId
        opt.houseType = houseType.slice(0, 1)
        let data = await userReserve(opt)
        if (data.code == 0) {
            this.setState({
                isYuyue: false
            }, () => {
                message.success('预约成功')
                this.getLineup()
            })
        } else {
            this.setState({
                isYuyue: false
            }, () => {
                message.error(data.message);
            })
        }
    }
    baiduMapSearch = (w) => {
        this.setState({
            mapListContainerLoading: false,
            baiduIndex: w
        })
        let map
        const point = window.point
        let options = {
            renderOptions: {
                map: this.map,
                autoViewport: false,
                selectFirstResult: false,
                panel: 'mapListContainer'
            },
            function(results) {
                // 判断状态是否正确
                if (this.local.getStatus() == 'BMAP_STATUS_SUCCESS') {
                    let s = []
                    for (let i in results.getCurrentNumPois()) {
                        let content = {
                            title: results.getPoi(i).title,
                            address: results.getPoi(i).address,
                            point: results.getPoi(i).point
                        }
                        s.push(content);
                    }
                }
            }

        }
        this.map.clearOverlays();
        this.map.centerAndZoom(point, 16);
        this.map.addOverlay(new window.BMap.Marker(point));
        this.map.addControl(new window.BMap.NavigationControl());
        let circle = new window.BMap.Circle(point, 1000, { fillColor: "#ccc", strokeWeight: 1, fillOpacity: 0.2, strokeOpacity: 0.2 });
        this.map.addOverlay(circle);
        let local = new window.BMap.LocalSearch(this.map, options);
        local.searchNearby(w, point, 1000);
        setTimeout(() => {
            this.setState({
                mapListContainerLoading: true
            })
        })
    }
    aMapSearch = (w) => {
        this.setState({
            mapListContainerLoading: false,
            baiduIndex: w
        })
        console.log(w);
        let map = this.map
        const point = window.point
        map.clearMap();
        let marker = new AMap.Marker({
            position: new AMap.LngLat(point[0], point[1]),
        });
        map.add([marker]);
        AMap.plugin(["AMap.PlaceSearch"], function () {
            // //构造地点查询类
            var placeSearch = new AMap.PlaceSearch({
                pageSize: 5, // 单页显示结果条数
                pageIndex: 1, // 页码
                city: "上海市", // 兴趣点城市
                citylimit: true,  //是否强制限制在设置的城市内搜索
                map: map, // 展现结果的地图实例
                panel: "mapListContainer", // 结果列表将在此容器中进行展示。
                autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
            });
            placeSearch.searchNearBy(w, point, 1000, function (status, result) {
            });
        });

        setTimeout(() => {
            this.setState({
                mapListContainerLoading: true
            })
        })
    }
    setMap = (location) => {
        let _self = this
        var myGeo = new window.BMap.Geocoder();
        myGeo.getPoint(location, function (point) {
            if (point) {
                window.point = point
                _self.baiduMapSearch('地铁站')
            }
        })
    }
    setAMap = (location) => {
        let _self = this
        var myGeo = new window.AMap.Geocoder();
        var marker = new AMap.Marker();
        myGeo.getLocation(location, function (status, result) {
            console.log(result);
            if (status === 'complete' && result.geocodes.length) {
                var lnglat = result.geocodes[0].location
                window.point = [lnglat.lng, lnglat.lat]
                _self.aMapSearch('地铁站')
            } else {
                message.error('根据地址查询位置失败');
            }
        })
    }
    getprojectDetailInfo = async (projectName, projectNo) => {
        this.setState({
            loading: true
        })
        let opts = {
            // projectName: projectName,
            projectNo: projectNo,
            // userId: this.props.userLoginInfo ? this.props.userLoginInfo.id : null
        }
        this.setState({
            projectNo: projectNo
        })
        let data = await projectWebDetailInfo(opts)
        if (data.code == 0) {
            let projectdata = data.data
            if (projectdata.mediaUrl) {
                projectdata.mediaUrl = projectdata.mediaUrl.split(',')
            }
            projectdata = projectdata
            this.setState({
                projectList: projectdata,
                defaultRoom: projectdata.roomTypeInfos.split(',')[0],
                dataLocation: projectdata.location,
                dataCommunityName: projectdata.projectName,
            }, () => {
                let obj = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10 }
                let houseType = obj[this.state.defaultRoom]
                this.setRoomTypeByProject(projectName, houseType)
            })
        }

        let _self = this
        const { projectList } = this.state
        this.setState({
            loading: false
        }, () => {
            _self.initSwiper()
            // _self.setMap(projectList.location)
            // _self.map = new window.BMap.Map("mapContainer");
            // _self.map.enableScrollWheelZoom(true);
            // _self.initSwiper()
            // _self.setState({
            //     baiduLoading: true
            // })
            // _self.setAMap(projectList.location)
            // _self.map = new window.AMap.Map("mapContainer", {
            //     resizeEnable: true
            // });
            // _self.map.enableScrollWheelZoom(true);
            _self.setState({
                baiduLoading: true
            })
        })
    }
    setRoomTypeByProject = async (projectName, roomType) => {
        let opts = {
            projectName: projectName,
            roomType: roomType,
        }
        let data = await getRoomTypeByProject(opts)
        if (data?.code == 0) {
            let roomTypeMsg = data.data[0]
            roomTypeMsg.houseTypeList.forEach(function (item) {
                item.roomLabel = item.roomLabel ? item.roomLabel.split(',') : ''
                item.towards = item.towards ? item.towards.split(',') : ''
                item.roomPicUrl = item.roomPicUrl ? item.roomPicUrl.split(',') : ''
            });
            this.setState({
                roomTypeMsg: roomTypeMsg
            })
        } else {
            message.error(data?.message)
        }
    }
    initSwiper() {
        let galleryTopDom = document.getElementById('galleryTop')
        let galleryThumbsDom = document.getElementById('galleryThumbs')
        var galleryThumbs = new window.Swiper(galleryThumbsDom, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
        });
        var galleryTop = new window.Swiper(galleryTopDom, {
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: this.refs.swiperNext,
                prevEl: this.refs.PrevEl,
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });
    }
    tableBody = (item, index) => {
        return (
            // <div key={index} className="swiper-slide" style={{ background: "url(" + item + ") ", backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: '50% 50%' }}>
            // </div>
            <img src={item} alt="" style={{ width: '100%', maxWidth: '100%', cursor: 'pointer', objectFit: 'contain' }} key={index} className="swiper-slide" />
        )
    }
    roomTypeName = (item, index) => {
        return (
            <Radio.Button key={index} value={item}>{item}室户</Radio.Button>
        )
    }
    roomTypeBody = (item, index) => {
        const towards = ['#ADF9E3', '#F9C4C4', '#2db7f5', '#87d068']
        return (
            <div key={index} className="mobileRoomTypeBody">
                <Row style={{ background: '#FAFAFAFF', padding: '10px' }}>
                    <Col className="flex alignC imagesBox">
                        <div
                            style={{ width: '100%', height: '160px' }}
                            className="imgHouseType"
                        >
                            <img src={item.roomPicUrl[0]} alt="" style={{ width: '100%', maxWidth: '100%', cursor: 'pointer', objectFit: 'contain' }} width={208} height={156} onClick={() => { this.showModal('houseType', index) }} />
                            {/* <div
                    style={{
                      width: '100%',
                      height: '100%',
                      background: 'url("' + item.roomPicUrl[0] + '") center / contain no-repeat',
                    //   backgroundSize: 'cover',
                    //   backgroundPosition: '50% 50%',
                      cursor: 'pointer',
                    //   backgroundRepeat: 'no-repeat',
                    }}
                    onClick={() => {
                      this.showModal('houseType', index)
                    }}
                  /> */}
                        </div>
                    </Col>
                    <Col className="contentBox">
                        <div
                            className="roomTypeBodyLeft"
                            style={{ overflow: 'hidden' }}
                        >
                            <div className="belowsDom flex alignC justSb">
                                <div>
                                    <h3
                                        className={'fl'}
                                        style={{ fontSize: '20px', fontWeight: '600' }}
                                    >
                                        {item.houseTypeName}&nbsp;&nbsp;
                                    </h3>
                                    {item.vrUrl && item.vrUrl.length > 0 ? (
                                        <Button
                                            className={'fs'}
                                            type="primary"
                                            style={{
                                                borderRadius: '20px',
                                                height: '22px',
                                                lineHeight: '20px',
                                                fontSize: '12px',
                                                padding: '0 8px',
                                            }}
                                            href={item.vrUrl}
                                            target="_blank"
                                        >
                                            VR
                                        </Button>
                                    ) : null}
                                </div>
                                <div>
                                    租金{' '}
                                    <span
                                        className="mobileBelowsRent"
                                        style={{ color: '#FA6400' }}
                                    >
                                        <span className="mobileBelowsRentText">
                                            {item.monthlyRent}
                                        </span>
                                        元/月
                                    </span>
                                </div>
                            </div>
                            <div className={'belowsDom'}>
                                <Row span={24}>
                                    <div className="contentInfo">
                                        <Col
                                            style={{
                                                marginBottom: '0 ',
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                            }}
                                            className="contentInfoLabel"
                                        >
                                            房型
                                        </Col>
                                        <Col
                                            style={{
                                                color: 'rgba(0, 0, 0, 0.5)',
                                                fontSize: '15px',
                                            }}
                                            className="contentInfoValue"
                                        >
                                            {item.roomType.substr(0, 1)}室
                                            {item.roomType.substr(1, 1)}厅
                                            {item.roomType.substr(2, 1)}卫
                                        </Col>
                                    </div>
                                    <div className="contentInfo">
                                        <Col
                                            style={{
                                                marginBottom: '0 ',
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                            }}
                                            className="contentInfoLabel"
                                        >
                                            面积
                                        </Col>
                                        <Col
                                            style={{
                                                color: 'rgba(0, 0, 0, 0.5)',
                                                fontSize: '15px',
                                            }}
                                            className="contentInfoValue"
                                        >
                                            {item.area}㎡
                                        </Col>
                                    </div>
                                </Row>
                                <Row span={24} className="contentInfoPc">
                                    <div className="contentInfo">
                                        <Col
                                            style={{
                                                marginBottom: '0 ',
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                            }}
                                            className="contentInfoLabel"
                                        >
                                            房屋朝向
                                        </Col>
                                        <Col
                                            style={{
                                                color: 'rgba(0, 0, 0, 0.5)',
                                                fontSize: '15px',
                                            }}
                                            className="contentInfoValue"
                                        >
                                            {item.towards && item.towards.length > 0
                                                ? item.towards.map((pan, index) => (
                                                    <Tag color={towards[index]} style={{ color: '#808080' }} key={index}>
                                                        {pan}
                                                    </Tag>
                                                ))
                                                : null}
                                        </Col>
                                    </div>
                                    <div className="contentInfo">
                                        <Col
                                            style={{
                                                marginBottom: '0 ',
                                                color: 'rgba(0, 0, 0, 0.6)',
                                                fontSize: '15px',
                                                fontWeight: '600',
                                            }}
                                            className="contentInfoLabel"
                                        >
                                            房型配置
                                        </Col>
                                        <Col
                                            style={{
                                                color: 'rgba(0, 0, 0, 0.5)',
                                                fontSize: '15px',
                                            }}
                                            className="contentInfoValue"
                                        >
                                            {item.roomEquipment}
                                        </Col>
                                    </div>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
                <div style={{ width: '100%', height: '1em' }}></div>
            </div>
        )
    }
    houseTypeBody = (item, index) => {
        return (
            <div key={index}  >
                {item.houseStatus == 2 ? <Row gutter={[16, 16]} style={{ borderBottom: '1px solid #ddd', padding: '30px 10px 30px 10px ', }}>
                    <Col xs={9} sm={6} md={5} lg={5} xl={4}>
                        <img src={item.roomPicUrl[0]} alt="" style={{ cursor: 'pointer' }} width={114} height={85} onClick={() => { this.showModal('house', index) }} />
                    </Col>
                    <Col xs={9} sm={12} md={14} lg={14} xl={16}>
                        <div style={{ overflow: 'hidden' }} >
                            <div className={'belowsDom'}>
                                <h3 className={'fl'} style={{ fontSize: '20px', fontWeight: '600' }}>{item.houseNo}&nbsp;&nbsp;</h3>
                            </div>
                            <h3 className={'fl'} style={{ fontSize: '18px', fontWeight: '600', color: '#FA6400' }}>{item.monthlyRent}&nbsp;<span style={{ fontSize: '14px', }}>元/月</span> </h3>
                            <div className={'belowsDom'}>
                                <Row>
                                    <Col style={{ color: 'rgba(0, 0, 0, 0.5)', fontSize: '15px' }}>{item.roomType}&nbsp;&nbsp;{item.roomTypeName}&nbsp;&nbsp;{item.area}㎡&nbsp;&nbsp;{item.towards}&nbsp;&nbsp;{item.buildingFloor}楼</Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                    <Col xs={5} sm={6} md={5} lg={5} xl={4}>
                        {/* <Button onClick={() => { this.setUserReserve(item.houseId, item.roomType, item.houseNo) }} style={{ height: '40px', margin: '10px 0', borderRadius: '30px' }} type="primary" ghost>
                            预约看房
                        </Button> */}
                        <Button onClick={() => { this.showYuyue(item.houseId, item.roomType, item.houseNo) }} style={{ height: '40px', margin: '10px 0', borderRadius: '30px' }} type="primary" ghost>
                            预约看房
                        </Button>
                    </Col>
                    <div style={{ width: '100%', height: '1em' }}></div>
                </Row> : null}
            </div>
        )

    }
    changeRoomType = (e) => {
        let eValue = e.target.value
        let obj = { '一': 1, '二': 2, '三': 3, '四': 4, '五': 5, '六': 6, '七': 7, '八': 8, '九': 9, '十': 10 }
        let houseType = obj[eValue]
        this.setState({
            defaultRoom: eValue
        })
        this.setRoomTypeByProject(this.state.projectName, houseType)
    }
    callbackBtn = (key) => {
        let selectTabArr = key.split(',')
        this.setState({
            selectTabArr: selectTabArr,
        })
        this.aMapSearch(selectTabArr[0])
    }
    totalTabPane = (item, index) => {
        return (
            <TabPane tab={item} key={item} style={{ padding: '0 1em' }}></TabPane>
        )
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }
    paiduishowModal = async () => {
        let opt = {}
        opt.userId = this.props.userLoginInfo.id
        let data = await getApplyingTransaction(opt)
        if (data.code == 0) {
            this.setState({
                isModalVisible: true,
                applyType: data.data.applyType
            })
        } else {
            message.error(data.message);
        }
    };

    paiduihandleOk = () => {
        if (this.state.paiduiHouseType) {
            this.setState({
                isModalVisible: false,
            })
            this.onLineup()
        } else {
            message.error('请输入户型')
        }
    };

    getidnoG = (value) => {
        let idnoG = null
        let values = value == undefined ? '' : value
        console.log(value)
        if (values.length == '18') {
            //获取年龄
            const myDate = new Date();
            const month = myDate.getMonth() + 1;
            const day = myDate.getDate();
            let age = myDate.getFullYear() - values.substring(6, 10) - 1;
            if (values.substring(10, 12) < month || values.substring(10, 12) == month && values.substring(12, 14) <= day) {
                age++;
            }
            // jsGetAge
            //年龄 age
            //获取性别
            if (parseInt(values.substr(16, 1)) % 2 == 1) {
                //是男则执行代码 ..
                if (age >= 25) {
                    idnoG = true
                } else {
                    idnoG = false
                }
                //是女则执行代码 ..
            } else {
                if (age >= 23) {
                    idnoG = true
                } else {
                    idnoG = false
                }
            }
        }
        this.setState({
            idnoJiaoyan: idnoG
        })
    }
    hoseTypeChange = (key) => {
        this.setState({
            paiduiHouseType: key
        })
    }
    showModal = (type, index) => {
        if (type === 'houseType') {
            this.setState({
                houseTypeAIndex: index,
                houseTypeVisible: true,
            });
        }
        if (type === 'house') {
            this.setState({
                houseIndex: index,
                houseVisible: true,
            });
        }
    };
    showBigImg = (url) => {
        window.open(url + "?download=0")
    }
    handleCancel = () => {
        this.setState({ houseTypeVisible: false, houseVisible: false, isYuyue: false, isModalVisible: false });
    };
    render() {
        const { idnoJiaoyan, projectList, loading, projectName, selectTabArr, mapListContainerLoading, defaultRoom, roomTypeMsg, baiduIndex, baiduLoading, isLineup, isSubscribe, houseList, houseTypeVisible, houseVisible, current, totalHouseList, isModalVisible, paiduiHouseType, houseTypeAIndex, houseIndex, applyType, isYuyue, dataCommunityName, dataLocation } = this.state
        const content = (
            <div style={{ maxWidth: '500px' }}>
                <p>{projectList.textContent}</p>
            </div>
        );
        return (
            <div id={'belows'} style={{ background: '#fff' }}>
                <Top />
                {!loading ? <div className='belowsBlock' style={{ display: 'inline-block', width: '100%', background: '#fafafa', padding: '25px 0', marginTop: '2px' }} >
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <div style={{ paddingLeft: '7px', marginBottom: '1.8em' }}>
                            <Breadcrumb separator=">">
                                <Breadcrumb.Item>房源项目</Breadcrumb.Item>
                                <Breadcrumb.Item>{projectName}</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        <Layout style={{ background: '#fafafa', }}>
                            <Row>
                                <Col span={12} style={{ height: '500px' }}>
                                    <div className="swiper mySwiper2" id={'galleryTop'}>
                                        <div className="swiper-wrapper">
                                            {projectList && projectList.mediaUrl && projectList.mediaUrl.length > 0 ? projectList.mediaUrl.map(this.tableBody) : null}
                                            {/* {mediaUrl.map(this.tableBody)} */}
                                        </div>
                                        <div className="swiper-button-next iconfont" style={{ backgroundImage: 'none', background: 'rgba(26, 56, 156, 0.4)', borderRadius: '50%', width: '45px', height: '45px', right: '35px', lineHeight: '45px', textAlign: 'center', color: '#fff', fontSize: '18px', transform: 'rotate(180deg)' }} ref={'swiperNext'}>&#xe65e;</div>
                                        <div className="swiper-button-prev iconfont" style={{ backgroundImage: 'none', background: 'rgba(26, 56, 156, 0.4)', borderRadius: '50%', width: '45px', height: '45px', left: '35px', lineHeight: '45px', textAlign: 'center', color: '#fff', fontSize: '18px' }} ref={'PrevEl'}>&#xe65e;</div>
                                    </div>
                                    <div className="swiper mySwiper" id={'galleryThumbs'}>
                                        <div className="swiper-wrapper">
                                            {projectList && projectList.mediaUrl && projectList.mediaUrl.length > 0 ? projectList.mediaUrl.map(this.tableBody) : null}
                                            {/*{mediaUrl.map(this.tableBody)}*/}
                                        </div>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div style={{ padding: '0 44px' }}>
                                        <div style={{ color: '#023189', fontSize: '36px', borderBottom: '2px solid #023189', lineHeight: '3em' }}>
                                            <span>{projectList.projectName}</span>
                                            {/* <span style={{ float: 'right' }}>
                                                <Popover placement="bottom" content={content} title="项目简介" trigger="hover">
                                                    <Button style={{ fontSize: '32px', background: '#fafafa', border: 'none', boxShadow: 'none', }}><EllipsisOutlined /></Button>
                                                </Popover>

                                            </span> */}
                                        </div>
                                        <span style={{ color: 'rgba(0, 0, 0, 0.5)', lineHeight: '2em', fontSize: '16px' }}>
                                            <ul className='projectDetails'>
                                                <li>
                                                    <span className='labele'>所在街道/镇 :</span>
                                                    {projectList.layout}
                                                </li>
                                                <li>
                                                    <span className='labele'>所在位置 :</span>
                                                    {projectList.location}
                                                </li>
                                                {/* {projectList.supplyTarget ? <li>
                                                    <span className='labele'>供应对象 :</span>
                                                    {projectList.supplyTarget}
                                                </li> : null} */}
                                                {/* <li>
                                                    <span className='labele'>所在版块 :</span>
                                                    {projectList.layout}
                                                </li> */}
                                                <li>
                                                    <span className='labele'>供应日期 :</span>
                                                    {projectList.openingDate}
                                                </li>
                                                <li>
                                                    <span className='labele'>总套数 :</span>
                                                    {projectList.totalCount || 0}套
                                                </li>
                                                <li>
                                                    <span className='labele'>总可租数 :</span>
                                                    {projectList.kezuCount || 0}套
                                                </li>
                                                <li>
                                                    <span className='labele'>总建筑面积 :</span>
                                                    {projectList.totalArea || 0}㎡
                                                </li>
                                                <li>
                                                    <span className='labele'>项目户型 :</span>
                                                    {projectList.roomTypeCount || ''}
                                                    {/* {
                                                        projectList.openQueue === '1' ? (projectList && projectList.roomTypeCount ? projectList.roomTypeCount.split(',').map((el, index) => { return (<div key={index} style={{ float: 'left', width: '82%' }}>{index == 0 ? "" : <span className='labele'></span>}{el}</div>) }) : null) : (
                                                            projectList && projectList.roomTypeInfos ? projectList.roomTypeInfos.split(',').map((el, index) => { return (<div key={index} style={{ float: 'left', width: '82%' }}>{index == 0 ? "" : <span className='labele'></span>}{el}室户</div>) }) : null
                                                        )
                                                    } */}

                                                </li>
                                                <li>
                                                    <span className='labele'>单价 :</span>
                                                    {projectList.minUnitPrice ? projectList.minUnitPrice + '元/月/㎡' : ''}
                                                </li>
                                                <li style={{
                                                    whiteSpace: 'normal'
                                                }}>
                                                    <span className='labele'>项目介绍 :</span>
                                                    <div>
                                                        {projectList.textContent}
                                                    </div>
                                                </li>
                                                {/* {projectList.supplyTarget == '重点企事业单位' ? <li>
                                                    <div style={{
                                                        color: '#3d3d3d', backgroundColor: '#e6f7ff', border: '1px solid #91d5ff', width: 'auto', padding: '5px 20px'
                                                    }}>
                                                        该项目为定向供应项目，暂不开放社会面排队
                                                    </div>
                                                </li> : null} */}
                                            </ul>
                                        </span>
                                    </div>
                                </Col></Row>
                        </Layout>
                    </div>
                    <div className="col-lg-2"></div>
                </div> : ''}
                {!loading ? <div style={{ display: 'inline-block', width: '100%', margin: '32px 0' }}>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-8">
                        <Layout style={{ background: '#fff' }}>
                            <Row gutter={[16, 40]} >
                                <div className='belowsNone setBlock' style={{ marginTop: '-32px', width: '100%', display: 'none' }}>
                                    <div style={{ width: '100%', overflow: 'hidden' }}>
                                        <Swiper
                                            modules={[Navigation, Scrollbar, A11y, Autoplay]}
                                            slidesPerView={1}
                                            navigation
                                            // autoplay
                                            // pagination={{ clickable: true }}
                                            scrollbar={{ draggable: true }}

                                        >
                                            {projectList && projectList.mediaUrl && projectList.mediaUrl.length > 0 ?
                                                projectList.mediaUrl.map((item, index) => {
                                                    return (<SwiperSlide key={item} virtualIndex={index}>
                                                        {/* <div style={{ background: 'url(' + item + ')', backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%', width: '100%', height: '250px' }}></div> */}
                                                        <img src={item} style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                                    </SwiperSlide>)
                                                })
                                                : 'null'
                                            }
                                        </Swiper>
                                    </div>
                                    <div style={{ fontSize: '28px', color: '#1A389C', lineHeight: '2em', fontWeight: 'bold' }}>&nbsp;{projectName}</div>
                                </div>
                                <Col className='belowsNone' span={24} style={{ paddingTop: '10px', paddingBottom: '10px', display: 'none' }}>
                                    <Descriptions title="项目信息">
                                        <Descriptions.Item label="所在街道/镇">{projectList.layout}</Descriptions.Item>
                                        <Descriptions.Item label="所在位置">{projectList.location}</Descriptions.Item>
                                        {/* <Descriptions.Item label="所在版块">{projectList.layout}</Descriptions.Item> */}
                                        <Descriptions.Item label="供应日期">{projectList.openingDate}</Descriptions.Item>
                                        <Descriptions.Item label="总套数">{projectList.totalCount || 0}套</Descriptions.Item>
                                        <Descriptions.Item label="总可租数">{projectList.kezuCount || 0}套</Descriptions.Item>
                                        <Descriptions.Item label="总建筑面积">{projectList.totalArea || 0}㎡</Descriptions.Item>
                                        <Descriptions.Item label="项目户型">{projectList.roomTypeCount || ''}</Descriptions.Item>
                                        <Descriptions.Item label="单价">{projectList.minUnitPrice ? projectList.minUnitPrice + '元/月/㎡' : ''}</Descriptions.Item>
                                        <Descriptions.Item label="项目介绍">{projectList.textContent || ''}</Descriptions.Item>
                                    </Descriptions>
                                </Col>
                                <Col span={24} id={'fangxing'}>

                                    <Descriptions
                                        className='houseType'
                                        style={{ fontSize: '40px' }}
                                        title="房型信息"
                                        extra={isLineup ? <Tooltip title={projectList ? projectList.openQueue == '0' ? '此项目为定向供应项目，暂不对外开放。' : projectList.openQueue == '1' ? '' : '此项目为定向供应项目，暂不对外开放。' : '此项目为定向供应项目，暂不对外开放。'}>
                                            <Button type="primary" onClick={() => tapOnce(this.paiduishowModal, null)} disabled={projectList ? projectList.openQueue == '0' ? true : projectList.openQueue == '1' ? false : true : true} style={{ borderRadius: '20px' }}>发起排队</Button></Tooltip> : null}
                                    >
                                    </Descriptions>
                                    <div style={{ margin: '0 3px' }}>
                                        <Radio.Group value={defaultRoom} buttonStyle="solid" onChange={(e) => tapOnce(this.changeRoomType, e)} style={{ marginBottom: '10px' }}>
                                            {projectList && projectList.roomTypeInfos.length > 0 ? projectList.roomTypeInfos.split(',').map(this.roomTypeName) : null}
                                        </Radio.Group>

                                    </div>
                                    {projectList.openQueue == '1' ? <div style={{ margin: '0 -8px' }}>
                                        <Descriptions >
                                            <Descriptions.Item label="可租数">{roomTypeMsg.kezuCount}</Descriptions.Item>
                                            <Descriptions.Item label="排队人数">{roomTypeMsg.queueCount}</Descriptions.Item>
                                            <Descriptions.Item label="租金区间">{roomTypeMsg.minRent}元/月-{roomTypeMsg.maxRent}元/月</Descriptions.Item>
                                        </Descriptions></div> : null}
                                    <div style={{ width: '100%', height: '1em' }}></div>
                                    {roomTypeMsg.houseTypeList && roomTypeMsg.houseTypeList.length > 0 ? roomTypeMsg.houseTypeList.map(this.roomTypeBody) : null}
                                </Col>
                                {houseList && houseList.length > 0 ? <Col span={24} id={'fangyuan'}>
                                    <Descriptions
                                        title="房源列表"
                                    >
                                    </Descriptions>
                                    <div style={{ width: '100%', height: '1em', borderBottom: '1px solid  #ddd' }}></div>
                                    {houseList.map(this.houseTypeBody)}
                                    <Pagination current={current} onChange={this.changeCurrent} total={totalHouseList} pageSize={10} style={{ float: 'right', margin: '20px' }} />
                                </Col> : null}
                                {dataCommunityName ? <Col span={24}>
                                    <SurroundingFacility dataLocation={dataLocation} dataCommunityName={dataCommunityName} />
                                </Col> : null}
                                {/* <Col span={24}>
                                    <Descriptions title="周边配套" className='zhoubian'>
                                        <div style={{ position: 'relative' }}>
                                            <div id="mapContainer" style={{ width: '100%', height: '500px' }}></div>
                                            <div style={{ position: 'absolute', right: '18px', top: '24px', bottom: '24px', width: '385px', background: '#fff' }} className='mapCon'>
                                                <Tabs type="card" onChange={this.callbackBtn}>
                                                    <TabPane tab="交通" key="地铁站,公交站">
                                                    </TabPane>
                                                    <TabPane tab="教育" key="幼儿园,小学,中学,大学">
                                                    </TabPane>
                                                    <TabPane tab="医院" key="医院,药店">
                                                    </TabPane>
                                                    <TabPane tab="购物" key="超市,商场,菜市场,便利店">
                                                    </TabPane>
                                                    <TabPane tab="银行" key="营业厅,ATM">
                                                    </TabPane>
                                                    <TabPane tab="商业" key="商业">
                                                    </TabPane>
                                                    <TabPane tab="休闲" key="景点,广场">
                                                    </TabPane>
                                                </Tabs>
                                                {baiduLoading ? <Tabs activeKey={baiduIndex} onChange={(key) => { this.aMapSearch(key) }}>
                                                    {selectTabArr.length > 0 ? selectTabArr.map(this.totalTabPane) : null}
                                                </Tabs> : null}
                                                <div id='mapListContainer' style={{ height: '330px', overflow: 'auto' }}></div>
                                                {mapListContainerLoading ? null : <Spin style={{ position: 'absolute', top: '50%', left: '50%' }} />}
                                            </div>

                                        </div>
                                    </Descriptions>
                                </Col> */}
                            </Row>
                        </Layout>
                    </div>
                    <div className="col-lg-2"></div>
                </div> : <Spin style={{ width: '100%', height: '600px', lineHeight: '600px' }} />}
                <Footer />
                <Modal title="确认预约看房" visible={isYuyue} onOk={() => { tapOnce(this.setUserReserve, null) }} onCancel={this.handleCancel}>
                    是否确认预约看房？
                </Modal>
                <Modal title="选择户型开始排队" visible={isModalVisible} onOk={() => tapOnce(this.paiduihandleOk, null)} onCancel={this.handleCancel}>
                    <Select defaultValue={paiduiHouseType} style={{ width: 120 }} onChange={this.hoseTypeChange}>
                        <Option value="" >请选择户型</Option>
                        {applyType != '单身' && projectList && projectList.roomTypeInfos.length > 0 ? projectList.roomTypeInfos.split(',').map((pan, index) => (<Option value={pan} key={index}>{pan}室户</Option>)) : null}
                        {applyType == '单身' && projectList && projectList.roomTypeInfos.length > 0 && projectList.roomTypeInfos.indexOf('一') !== -1 ? <Option value="一" >一室户</Option> : null}
                        {applyType == '单身' && idnoJiaoyan && projectList && projectList.roomTypeInfos.length > 0 && projectList.roomTypeInfos.indexOf('二') !== -1 ? <Option value="二" >二室户</Option> : null}
                    </Select>
                </Modal>
                <Modal
                    visible={houseTypeVisible}
                    width={1000}
                    onCancel={this.handleCancel}
                    footer={""}
                >
                    <Swiper
                        className="swiperModel"
                        modules={[Navigation, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                    // scrollbar={{ draggable: true }}
                    >
                        {roomTypeMsg && roomTypeMsg.houseTypeList && roomTypeMsg.houseTypeList[houseTypeAIndex] && roomTypeMsg.houseTypeList[houseTypeAIndex].roomPicUrl.length > 0 ?
                            roomTypeMsg.houseTypeList[houseTypeAIndex].roomPicUrl.map((item, index) => {
                                return (<SwiperSlide key={item} virtualIndex={index}>
                                    {/* <div style={{ background: 'url("' + item + '") no-repeat center ', backgroundSize: 'contain', width: '100%', height: '100%' }}>
                                    </div> */}
                                    <img src={item} style={{ width: '100%', maxWidth: '600px', height: '100%', maxHeight: '100%', objectFit: 'contain' }} onClick={() => { this.showBigImg(item) }} />
                                </SwiperSlide>)
                            })
                            : 'null'
                        }
                    </Swiper>
                </Modal>
                <Modal
                    visible={houseVisible}
                    width={800}
                    onCancel={this.handleCancel}
                    footer={""}
                >
                    <Swiper
                        modules={[Navigation, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        scrollbar={{ draggable: true }}
                    >
                        {houseList && houseList[houseIndex] && houseList[houseIndex].roomPicUrl && houseList[houseIndex].roomPicUrl.length > 0 ?
                            houseList[houseIndex].roomPicUrl.map((item, index) => {
                                return (<SwiperSlide key={item} virtualIndex={index}>
                                    <img src={item} style={{ width: '100%', maxWidth: '600px', marginLeft: '76px' }} />
                                </SwiperSlide>)
                            })
                            : 'null'
                        }
                    </Swiper>
                </Modal>
            </div>
        )
    }

}
// 引入userLoginInfo
const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo,
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(Belows)
